// extracted by mini-css-extract-plugin
export var arrow = "FAQDropdown-module--arrow--106e6";
export var arrowNo = "FAQDropdown-module--arrow_no--22101";
export var arrowYes = "FAQDropdown-module--arrow_yes--d5c9b";
export var dropdownAnswer = "FAQDropdown-module--dropdownAnswer--662e0";
export var dropdownChevronIcon = "FAQDropdown-module--dropdownChevronIcon--12bc5";
export var dropdownContent = "FAQDropdown-module--dropdownContent--4d08e";
export var dropdownHeader = "FAQDropdown-module--dropdownHeader--1d9a2";
export var dropdownQuestion = "FAQDropdown-module--dropdownQuestion--31bc6";
export var faqDropdown = "FAQDropdown-module--faqDropdown--b53e8";
export var flex = "FAQDropdown-module--flex--6e673";
export var flex1 = "FAQDropdown-module--flex_1--ecc33";
export var flexCenter = "FAQDropdown-module--flex_center--dd334";
export var flexCenterCol = "FAQDropdown-module--flex_center_col--513c7";
export var flexCol = "FAQDropdown-module--flex_col--f5298";
export var flexFixCenterCol = "FAQDropdown-module--flex_fix_center_col--ad50e";
export var flexFixedCenterCol = "FAQDropdown-module--flex_fixed_center_col--f850f";
export var open = "FAQDropdown-module--open--d8947";
export var rotating = "FAQDropdown-module--rotating--848b9";